__turbopack_context__.v({
  "authButtons": "navbar-module__U3kWGW__authButtons",
  "desktopSignupButton": "navbar-module__U3kWGW__desktopSignupButton",
  "loginButton": "navbar-module__U3kWGW__loginButton",
  "logo": "navbar-module__U3kWGW__logo",
  "mobileMenuToggle": "navbar-module__U3kWGW__mobileMenuToggle",
  "mobileSignupButton": "navbar-module__U3kWGW__mobileSignupButton",
  "navContainer": "navbar-module__U3kWGW__navContainer",
  "navContent": "navbar-module__U3kWGW__navContent",
  "navLinks": "navbar-module__U3kWGW__navLinks",
  "navbar": "navbar-module__U3kWGW__navbar",
  "showMobile": "navbar-module__U3kWGW__showMobile",
});
